import {StyleSheet, View} from 'react-native';
import Text from '@/components/basic/text';
import theme from '@/style';
import React from 'react';
import DigitBall from '../../components/digit-ball';

const ResultHeader = ({isQuick: _isQuick = false}: {isQuick?: boolean}) => {
  return (
    <View style={[theme.padding.tbs, theme.margin.lrl, styles.wrap]}>
      <View style={styles.issueCol}>
        <Text
          accent
          fontSize={12}
          fontFamily="fontInterBold"
          style={styles.headerText}>
          ISSUE
        </Text>
      </View>
      <View style={styles.timeCol}>
        <Text
          accent
          fontSize={12}
          fontFamily="fontInterBold"
          textAlign="center"
          style={styles.headerText}>
          TIME
        </Text>
      </View>
      <View style={styles.resultCol}>
        {['A', 'B', 'C'].map((item, _i) => (
          <DigitBall ballSize={24} digit={item} color={item} key={_i} />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#E9ECF5',
    borderTopLeftRadius: theme.paddingSize.s,
    borderTopRightRadius: theme.paddingSize.s,
    paddingHorizontal: 12,
  },
  issueCol: {
    width: 102,
  },
  timeCol: {
    width: 80,
    alignItems: 'center',
  },
  resultCol: {
    width: 80,
    flexDirection: 'row',
    gap: 4,
  },
  headerText: {
    textTransform: 'uppercase',
    lineHeight: 16,
  },
});

export default ResultHeader;
